export default "__VITE_ASSET__ImCg6xdu__"